import { render, staticRenderFns } from "./add-edit-cancel.vue?vue&type=template&id=4c628f42&scoped=true&"
import script from "./add-edit-cancel.vue?vue&type=script&lang=js&"
export * from "./add-edit-cancel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c628f42",
  null
  
)

export default component.exports